import {Scenario} from "../../../types";
import {PlayerReduxState} from "../types";

export default function getAdditionalScenarios(state: PlayerReduxState): Scenario[] {
  return state.scenarios.map((item) => item).filter((item) => !item.isMain);
}
